import { render, staticRenderFns } from "./switchLocale.vue?vue&type=template&id=76b65ed8&scoped=true&"
import script from "./switchLocale.vue?vue&type=script&lang=js&"
export * from "./switchLocale.vue?vue&type=script&lang=js&"
import style0 from "./switchLocale.vue?vue&type=style&index=0&id=76b65ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b65ed8",
  null
  
)

export default component.exports